import React from 'react';
import PropTypes from 'prop-types';
import { WarningMessage } from '../../../components/widgets';
import css from './PartnerSetupInformation.css';

function PartnerSetupInformation({ messages = null }) {
    // Return null if there are no messages to display
    if (!messages || messages.length === 0) {
        return null;
    }

    return (
        <div className={css.messageBox}>
            {messages.map((msg, idx) => (
                <WarningMessage key={msg} show showIcon={false} type="info" message={msg} />
            ))}
        </div>
    );
}

PartnerSetupInformation.propTypes = {
    messages: PropTypes.array,
};

export default PartnerSetupInformation;
